import { render } from "./NotificationItem.vue?vue&type=template&id=b2e346f2&scoped=true"
import script from "./NotificationItem.vue?vue&type=script&lang=js"
export * from "./NotificationItem.vue?vue&type=script&lang=js"

import "./NotificationItem.vue?vue&type=style&index=0&id=b2e346f2&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2e346f2"]])

export default __exports__